import { trackEvent, trackException } from '@/config/appInsights'

// Console output is enabled in development mode OR when VITE_DEBUG=true.
// Application Insights telemetry is always sent regardless of this flag.
const IS_DEV = import.meta.env.VITE_APP_ENV === 'development'
const IS_DEBUG = import.meta.env.VITE_DEBUG === 'true'
const IS_PROD = import.meta.env.VITE_APP_ENV === 'production'
const HAS_CONNECTION_STRING = Boolean(import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING)

const shouldConsole = IS_DEV || IS_DEBUG

function shouldTrack(): boolean {
  return IS_PROD || (HAS_CONNECTION_STRING)
}

function debug(message: string, properties?: Record<string, unknown>): void {
  if (shouldConsole) {
    console.debug('[DEBUG]', message, properties ?? '')
  }
}

function info(message: string, properties?: Record<string, unknown>): void {
  if (shouldConsole) {
    console.info('[INFO]', message, properties ?? '')
  }
  if (shouldTrack()) {
    trackEvent(message, properties as Record<string, string> | undefined)
  }
}

function warn(message: string, properties?: Record<string, unknown>): void {
  if (shouldConsole) {
    console.warn('[WARN]', message, properties ?? '')
  }
  if (shouldTrack()) {
    trackEvent(`WARN: ${message}`, properties as Record<string, string> | undefined)
  }
}

function error(message: string, err?: Error, properties?: Record<string, unknown>): void {
  if (shouldConsole) {
    console.error('[ERROR]', message, err ?? '', properties ?? '')
  }
  if (shouldTrack()) {
    const errorObj = err ?? new Error(message)
    trackException(errorObj, properties as Record<string, string> | undefined)
  }
}

export const log = { debug, info, warn, error }
